import * as rax from 'retry-axios';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import authModule from './AuthModule';

export const apiHeaders = {
    key: {
        xDocubirdAuth: "x-docubird-auth"
    },
    value: {
        xDocubirdAuth: "]c4&ql>@P3flVbPM#61bX}d3q<e=$f"
    }
}

export const localApiInstance = axios.create({
    baseURL: process.env.API_URL,
    headers: {
        [apiHeaders.key.xDocubirdAuth]: apiHeaders.value.xDocubirdAuth
    }
});

if (navigator.userAgent.indexOf("Trident") !== -1 || navigator.userAgent.indexOf("Edge") !== -1) {
    localApiInstance.interceptors.request.use(async (config) => {
        const jwtToken = await authModule.getDocubirdToken();
        if (jwtToken) {
            config.headers["Authorization"] = `Bearer ${jwtToken}`;
        } else {
            authModule.signOut();
        }
        return {
            ...config
        };
    });
}
else {
    localApiInstance.interceptors.request.use(async (config) => {
        const controller = new AbortController();
        const jwtToken = await authModule.getDocubirdToken();
        if (jwtToken) {
            config.headers["Authorization"] = `Bearer ${jwtToken}`;
        } else {
            controller.abort();
            authModule.signOut();
        }
        return {
            ...config,
            signal: controller.signal
        };
    });
}

// Attach retry-axios to the global axios and localApiInstance
rax.attach();
rax.attach(localApiInstance);

const retryCodes = [[100, 199], [408, 408], [429, 429], [500, 599]];
const altRetryCodes = [[100, 199], [408, 408], [429, 429], [501, 599]];
const retryAmount = 5;

export const axiosRetryGet = async (
    url: string,
    config?: AxiosRequestConfig,
    axiosInstance: AxiosInstance | typeof axios = axios
) => {

    const res = await axiosInstance.get(url, {
        ...config,
        raxConfig: {
            retry: retryAmount,
            httpMethodsToRetry: ["GET"],
            statusCodesToRetry: retryCodes,
            backoffType: "linear",
        }
    });

    return res;
}

export const axiosRetryPost = async (
    url: string,
    data: any = null,
    config?: AxiosRequestConfig,
    retryInternalServerError: boolean = true,
    axiosInstance: AxiosInstance | typeof axios = axios
) => {

    const res = await axiosInstance.post(url, data, {
        ...config,
        raxConfig: {
            retry: retryAmount,
            httpMethodsToRetry: ["POST"],
            statusCodesToRetry: retryInternalServerError ? retryCodes : altRetryCodes,
            backoffType: "linear",
        }
    });

    return res;
}

export const axiosRetryPut = async (url: string, data: any = null) => {

    const res = await axios.put(url, data, {
        raxConfig: {
            retry: retryAmount,
            httpMethodsToRetry: ["PUT"],
            statusCodesToRetry: retryCodes,
            backoffType: "linear",
        }
    });

    return res;
}

export const axiosRetryDelete = async (url: string) => {

    const res = await axios.delete(url, {
        raxConfig: {
            retry: retryAmount,
            httpMethodsToRetry: ["DELETE"],
            statusCodesToRetry: retryCodes,
            backoffType: "linear",
        }
    });

    return res;
}

export const axiosRetryPatch = async (url: string, data: any = null, config?: AxiosRequestConfig) => {

    const res = await axios.patch(url, data, {
        ...config,
        raxConfig: {
            retry: retryAmount,
            httpMethodsToRetry: ["PATCH"],
            statusCodesToRetry: retryCodes,
            backoffType: "linear",
        }
    });

    return res;
}